<template>
  <div v-if="lenders.length" class="lender-grid grid-x grid-margin-x" :class="computedGridClassNames">
    <LenderBlock v-for="lender in lenders" :key="lender.id" :lender="lender" class="cell" />
  </div>
  <p v-else class="no-lenders" v-html="noDataMessage" />
</template>

<script>
  import LenderBlock from '~/modules/users/components/frontend/lender-block'
  import i18n from './locales'

  export default {
    name: 'LenderGrid',
    i18n,
    components: {
      LenderBlock,
    },
    props: {
      lenders: {
        type: Array,
        default: () => ([]),
      },
      noDataMessage: {
        type: String,
        default: null,
      },
      numOnSmall: {
        type: Number,
        default: 3,
      },
      numOnMedium: {
        type: Number,
        default: 5,
      },
      numOnLarge: {
        type: Number,
        default: 6,
      },
    },
    computed: {
      computedGridClassNames () {
        return [
          `small-up-${this.numOnSmall}`,
          `medium-up-${this.numOnMedium}`,
          `large-up-${this.numOnLarge}`,
        ]
      },
      noLendersMessage () {
        return this.noDataMessage === null
          ? this.$t('noLenders')
          : this.noDataMessage
      },
    },
  }
</script>

<style lang="scss" scoped>
  .lender-grid {
    .lender-block {
      margin-bottom: 2rem;
    }
  }
  .no-lenders {
    font: {
      style: italic;
      weight: bold;
    }
    margin-top: 2rem;
    text-align: center;
  }
</style>
